"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarProbe = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var SolarProbe = (function (_super) {
    __extends(SolarProbe, _super);
    function SolarProbe() {
        return _super.call(this, {
            cost: 9,
            tags: [Tags_1.Tags.SPACE, Tags_1.Tags.SCIENCE],
            name: CardName_1.CardName.SOLAR_PROBE,
            cardType: CardType_1.CardType.EVENT,
            metadata: {
                cardNumber: 'C37',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.cards(1).slash().science(3).digit.played;
                }),
                description: 'Draw 1 card for every 3 science tags you have, including this.',
                victoryPoints: 1,
            },
        }) || this;
    }
    SolarProbe.prototype.play = function (player) {
        player.drawCard(Math.floor((player.getTagCount(Tags_1.Tags.SCIENCE) + 1) / 3));
        return undefined;
    };
    SolarProbe.prototype.getVictoryPoints = function () {
        return 1;
    };
    return SolarProbe;
}(Card_1.Card));
exports.SolarProbe = SolarProbe;
//# sourceMappingURL=SolarProbe.js.map